import * as t from "io-ts";
import { ContractAgreement } from "./ContractAgreement";
import { Document } from "./Document";
import { OnlinePresence } from "./OnlinePresence";
import { Pence } from "./Pence";
import { TradeType } from "./TradeType";
import { WorkType } from "./WorkType";

export const CompanyInfo = t.intersection([
  t.type({
    trade_type: TradeType,
    trade_type_name: t.string,
    trade_body: t.union([
      t.literal("none"),
      t.literal("acrib"),
      t.literal("aphc"),
      t.literal("assure"),
      t.literal("certass"),
      t.literal("elecsa"),
      t.literal("fensa"),
      t.literal("feta"),
      t.literal("gas_safe"),
      t.literal("hetas"),
      t.literal("napit"),
      t.literal("nfrc"),
      t.literal("niceic"),
      t.literal("other"),
    ]),
    trade_body_name: t.string,
    warranty_length: t.number,
    average_monthly_jobs: t.number,
    average_job_value: Pence,
    use_subcontractor: t.union([t.literal("yes"), t.literal("no")]),
  }),
  t.partial({
    trade_body_number: t.string,
    online_presence: OnlinePresence,
    insurance_document: Document,
    contract_agreement: ContractAgreement,
    work_types: t.array(WorkType),
  }),
]);

export interface CompanyInfo {
  trade_type: TradeType;
  trade_type_name: string;
  trade_body:
    | "none"
    | "acrib"
    | "aphc"
    | "assure"
    | "certass"
    | "elecsa"
    | "fensa"
    | "feta"
    | "gas_safe"
    | "hetas"
    | "napit"
    | "nfrc"
    | "niceic"
    | "other";
  trade_body_name: string;
  trade_body_number?: string;
  warranty_length: number;
  average_monthly_jobs: number;
  average_job_value: Pence;
  use_subcontractor: "yes" | "no";
  online_presence?: OnlinePresence;
  insurance_document?: Document;
  contract_agreement?: ContractAgreement;
  work_types?: Array<WorkType>;
}
